import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject, map, tap } from 'rxjs';

import { RoleService } from 'app/core/auth/role.service';
import { User } from 'app/core/user/user.types';

@Injectable({ providedIn: 'root' })
export class UserService {
    private _httpClient = inject(HttpClient);
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    private _activatedRoute = inject(ActivatedRoute);
    private _router = inject(Router);
    private _roleService = inject(RoleService);


    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }


    setUser(): any {
        this._roleService.user$().subscribe(
            (result: any) => {
                if (!result) { return; } // Respuesta de una sesión invalidada.
                localStorage.setItem('user-id', result.id);
                localStorage.setItem('user-name', result.name);
                localStorage.setItem('user-surnames', result.surnames);
                localStorage.setItem('user-email', result.email);
                if (result.avatar !== 'null' && result.avatar !== null) {
                    localStorage.setItem('user-avatar', result.avatar);
                } else {
                    localStorage.setItem('user-avatar', 'default.jpg');
                }
                localStorage.setItem('user-phone', result.phone);
                // RoleService ya guardó el rol de esta petición compartida (D53, D60).
                localStorage.setItem('authenticated', 'true');
                this._router.navigateByUrl('dashboard');
            },
        );

    }



    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current signed-in user data
     */
    get(): Observable<User> {
        return this._httpClient.get<User>('api/common/user').pipe(
            tap((user) => {
                this._user.next(user);
            }),
        );
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any> {
        return this._httpClient.patch<User>('api/common/user', { user }).pipe(
            map((response) => {
                this._user.next(response);
            }),
        );
    }
}
